export default __webpack_public_path__ + "static/media/html-logo.f4056d61.png";